
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Destinationweddingresortnearakola() {



  const cardData =
  {
    keyword: ' Destination Wedding Resorts Near Akola',
    heading:  'Woodland Escape: Destination Wedding Resorts Near Akola',
    headingDescription: 'Woodland Escape Resort, one of the most enchanting destination wedding resorts near Akola, offers a dreamy blend of natural beauty, elegance, and comfort to make your special day truly unforgettable. Surrounded by lush greenery, serene forest views, and open-air event spaces, the resort provides the perfect romantic backdrop for wedding ceremonies, receptions, and pre-wedding celebrations. Couples can exchange vows amidst nature, celebrate under the stars, and enjoy the convenience of modern amenities along with beautifully designed cottages for guests. With customizable decor, gourmet catering, and dedicated event support, Woodland Escape Resort near Akola transforms your wedding into a magical celebration filled with love, joy, and timeless memories.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



 "services": [
{
"name": "Destination Wedding Resorts Near Akola",
"description": "Woodland Escape Resort offers exquisite destination wedding resorts near Akola. Perfect for couples seeking a serene and scenic location, the resort combines natural beauty with luxurious wedding amenities. From outdoor lawns to indoor banquet halls, it accommodates intimate ceremonies as well as grand celebrations. The staff provides tailored wedding planning, décor, and catering to make your special day unforgettable."
},
{
"name": "Akola Wedding Resort Venue",
"description": "Plan your dream wedding at Woodland Escape Resort, one of the premier wedding resort venues near Akola. With beautifully landscaped gardens, luxurious accommodations, and dedicated wedding services, the resort ensures a flawless experience for couples and guests alike."
},
{
"name": "Akola Marriage Destination",
"description": "Woodland Escape Resort is a top-choice marriage destination in Akola, offering a perfect blend of elegance, comfort, and natural beauty. Celebrate your union with stunning views, outdoor ceremony options, and exquisite dining experiences tailored to your needs."
},
{
"name": "Akola Luxury Wedding Resort",
"description": "For couples seeking luxury, Woodland Escape Resort offers high-end wedding facilities near Akola. Experience lavish décor, premium catering, spacious banquet halls, and personalized services designed to create an unforgettable wedding celebration."
},
{
"name": "Affordable Wedding Resort Akola",
"description": "Woodland Escape Resort provides affordable wedding resort options near Akola without compromising on elegance or service quality. Enjoy beautiful venues, expert planning support, and tailored wedding packages that suit your budget."
},
{
"name": "Akola Pre Wedding Shoot Resort",
"description": "Capture your pre-wedding moments at Woodland Escape Resort in Akola. With scenic gardens, riverside views, and picturesque hills, the resort offers the perfect backdrop for romantic and memorable pre-wedding photoshoots."
},
{
"name": "Akola Outdoor Wedding Resort",
"description": "Host an outdoor wedding at Woodland Escape Resort with lush lawns, open-air dining spaces, and serene surroundings. The resort is ideal for couples looking for a natural and elegant wedding experience near Akola."
},
{
"name": "Akola Riverside Wedding Resort",
"description": "Woodland Escape Resort features riverside wedding venues near Akola, perfect for couples seeking tranquility and scenic beauty. The flowing water and greenery create a romantic ambiance for ceremonies and receptions."
},
{
"name": "Akola Hill Wedding Resort",
"description": "Celebrate your special day at Woodland Escape Resort’s hill wedding venue near Akola. Enjoy panoramic views, peaceful surroundings, and a unique elevated location for an unforgettable wedding experience."
},
{
"name": "Akola Family Wedding Resort",
"description": "Woodland Escape Resort is ideal for family weddings in Akola, offering ample space, family-friendly amenities, and dedicated staff to ensure comfort and enjoyment for all guests, from children to elders."
},
{
"name": "Akola Resort Wedding Packages",
"description": "Choose from a range of wedding packages at Woodland Escape Resort in Akola. Packages include venue decoration, catering, photography, entertainment, and accommodation options to create a seamless wedding celebration."
},
{
"name": "Akola Wedding Booking Online",
"description": "Easily book your wedding at Woodland Escape Resort near Akola online. Secure your preferred date, venue, and package, and get personalized support from the resort staff to plan a flawless wedding."
},
{
"name": "Akola Wedding Hall Resort",
"description": "Woodland Escape Resort offers elegant indoor wedding halls in Akola, suitable for ceremonies, receptions, and other events. The halls are equipped with modern amenities and décor options for a luxurious wedding experience."
},
{
"name": "Akola Resort for Marriage",
"description": "Celebrate your marriage at Woodland Escape Resort near Akola with exceptional facilities, scenic surroundings, and professional wedding planning services, ensuring a perfect and stress-free wedding day."
},
{
"name": "Akola Wedding Destination Packages",
"description": "Woodland Escape Resort provides comprehensive wedding destination packages in Akola, including venue, catering, décor, accommodation, and entertainment. Every detail is thoughtfully planned to make your wedding day extraordinary."
}
],
"tableData": [
["- Destination Wedding Resorts Near Akola", "- Akola Wedding Resort Venue"],
["- Akola Marriage Destination", "- Akola Luxury Wedding Resort"],
["- Affordable Wedding Resort Akola", "- Akola Pre Wedding Shoot Resort"],
["- Akola Outdoor Wedding Resort", "- Akola Riverside Wedding Resort"],
["- Akola Hill Wedding Resort", "- Akola Family Wedding Resort"],
["- Akola Resort Wedding Packages", "- Akola Wedding Booking Online"],
["- Akola Wedding Hall Resort", "- Akola Resort for Marriage"],
["- Akola Wedding Destination Packages", ""]
],
  


whychoose: [
  {
    "WhyChooseheading": "Dream Destination Wedding Resort Near Akola",
    "WhyChoosedescription": "Woodland Escape Resort offers an idyllic setting for destination weddings near Akola, combining forest‑charm with elegant spaces. Surrounded by lush trees and tranquillity, it provides a magical backdrop for couples who wish to celebrate their love amidst nature."
  },
  {
    "WhyChooseheading": "Beautiful Forest Ambience for Wedding Ceremonies",
    "WhyChoosedescription": "Celebrate your special day under the open sky, with the forest as your witness. Woodland Escape Resort features scenic forest clearings, natural light, and green surroundings that make every wedding moment photo‑worthy and memorable."
  },
  {
    "WhyChooseheading": "Versatile Venues and Styling Options",
    "WhyChoosedescription": "Whether you want a grand reception, intimate mehndi, or a private sangeet by the trees, Woodland Escape Resort provides flexible ceremony spaces and customizable décor. From lawn settings to elegant tents, the resort adapts to your wedding theme and vision."
  },
  {
    "WhyChooseheading": "Accommodation & Comfort for Guests",
    "WhyChoosedescription": "Guests staying for the wedding get comfortable accommodation surrounded by nature. Woodland Escape Resort offers rooms and cottages with forest views, so your wedding party and loved ones can relax, celebrate, and enjoy the surroundings together."
  },
  {
    "WhyChooseheading": "Catering & Local Flavours for Your Wedding Feast",
    "WhyChoosedescription": "Enhance your wedding celebration with delicious meals crafted from local, fresh ingredients. At Woodland Escape Resort, couples can choose menu options that reflect regional cuisine or global tastes — ensuring your wedding meal is both memorable and satisfying."
  },
  {
    "WhyChooseheading": "Ideal for Pre‑Wedding and Post‑Wedding Events",
    "WhyChoosedescription": "From welcome dinners and pre‑wedding shoots to farewell brunches, Woodland Escape Resort offers an all‑in‑one location for your full wedding weekend. The serene forest environment allows for meaningful moments and celebration without needing to move venues."
  },
  {
    "WhyChooseheading": "Convenient Access from Akola",
    "WhyChoosedescription": "Located near Akola, Woodland Escape Resort is easily reachable while still feeling like a true retreat. Its accessible location ensures fewer travel hassles for guests, making it a convenient yet special destination wedding choice."
  }
]











  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort for a destination wedding near Akola?",
    answer: "Woodland Escape Resort offers a serene countryside location, spacious event lawns, and accommodation facilities—all close to Akola. It’s an ideal destination wedding resort where you can combine ceremony, celebration and guest stay in one place."
  },
  {
    question: "How far is Woodland Escape Resort from Akola city?",
    answer: "The resort is located approximately 35‑40 km from Akola, which takes around 1 to 1.5 hours by car. It gives your guests the comfort of near‑city access while offering a tranquil destination feel."
  },
  {
    question: "What wedding facilities and event services are offered at the resort?",
    answer: "We provide full wedding event support including venue decoration, banquet/hall & lawn options, in‑house catering, accommodation for guests, sound & lighting, and event coordination. Whether you’re planning a grand affair or an intimate celebration, we’ll tailor it for you."
  },
  {
    question: "Can we host pre‑wedding functions, ceremony, and post‑wedding at the resort?",
    answer: "Absolutely! Woodland Escape Resort is perfect for engagement, mehendi, haldi, sangeet, wedding ceremony and reception. The property allows you to spread events over 1‑2 days so your celebrations flow smoothly and your guests stay comfortably onsite."
  },
  {
    question: "What accommodation options are available for wedding guests?",
    answer: "We offer comfortable rooms, cottages, and suites that can accommodate your wedding guests. The lodging is integrated with the event venue so your guests don’t have to travel between places — making it convenient and relaxing."
  },
  {
    question: "How do we book Woodland Escape Resort for a destination wedding near Akola?",
    answer: "You can connect with our wedding planning team via phone, WhatsApp or our website. We recommend booking well in advance — this allows us to customize your wedding package, secure the dates and work out the event logistics properly."
  }
];

const testimonials = [
  {
    name: "Mr. Kunal & Family, Akola",
    text: "Our wedding at Woodland Escape Resort was a dream come true! From the lush green surroundings to the thoughtful accommodation and excellent catering — everything was perfect. Guests were comfortable and the venue added magic to our celebrations."
  },
  {
    name: "Miss. Divya & Team, Akola",
    text: "Choosing Woodland Escape Resort for our destination wedding near Akola was the best decision! The lawn looked beautiful, staff was very cooperative, and we could host all functions in one place. Highly recommended for couples wanting something special."
  }
];











      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Destination Wedding Resorts Near Akola",
  "image": "https://woodlandescape.com/assets/images/destination-wedding-resorts-near-akola.jpg",
  "description": "Host your dream wedding at Woodlandescape Resort — one of the best destination wedding resorts near Akola. Enjoy luxury amenities, scenic outdoor settings, pre-wedding shoots, and expert wedding planning for a memorable celebration.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "612"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "99999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/destination-wedding-resorts-near-akola"
  }
};




  return (
    <div>
<Helmet>
  <title>Destination Wedding Resorts Near Akola | Luxury Wedding Venue | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Celebrate your special day at Woodlandescape Resort — a top destination wedding resort near Akola. Perfect for luxury weddings, pre-wedding shoots, outdoor celebrations, and unforgettable memories." 
  />
  <meta 
    name="keywords" 
    content="Destination Wedding Resorts Near Akola, Akola Wedding Resort Venue, Akola Marriage Destination, Akola Luxury Wedding Resort, Affordable Wedding Resort Akola, Akola Pre Wedding Shoot Resort, Akola Outdoor Wedding Resort, Akola Riverside Wedding Resort, Akola Hill Wedding Resort, Akola Family Wedding Resort, Akola Resort Wedding Packages, Akola Wedding Booking Online, Akola Wedding Hall Resort, Akola Resort for Marriage, Akola Wedding Destination Packages" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/12.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Destinationweddingresortnearakola;